window.addEventListener('load', event => {
    let scrolledY = window.scrollY;
    let zoomTargets = document.querySelectorAll('.scroll-zoom-target');
    let topValue = 1;

    for (let zoomTarget of zoomTargets) {
        const intersectionChanged = function (entry) {
            if (entry.isIntersecting) {
                document.addEventListener('scroll', throttleScroll, {passive: true})
            } else {
                document.removeEventListener('scroll', throttleScroll);
            }
        };

        const callback = (entries, observer) => {
            entries.forEach(intersectionChanged);
        };

        const options = {
            threshold: 0.1
        };

        const observer = new IntersectionObserver(callback, options);
        observer.observe(zoomTarget);

        let throttleScroll =  _throttle(rowZoom, 16, {leading: true, trailing: true});

        const setZoomOnLoad = setTimeout(throttleScroll, 50);

        rowZoom(true);

        function rowZoom(onLoad) {
            let scrollTop = window.scrollY;
            if ((scrollTop != scrolledY) || (onLoad === true)) {
                let targetChild = zoomTarget.querySelector('.scroll-zoom-target-child');
                let topOfTarget = zoomTarget.getBoundingClientRect().top;
                let centerOfTarget = topOfTarget + (zoomTarget.offsetHeight * .5);
                let windowHeight = window.innerHeight;
                let yPositionPxFromTop = centerOfTarget;
                let yPositionPercent = Math.round(centerOfTarget / windowHeight * 100) / 100;
                let scaleAmount = null;
                let opacityAmount = 1;

                if (yPositionPxFromTop >= 120 && yPositionPercent <= .95) {
                    zoomTarget.classList.remove('blur-md');
                    scaleAmount = 1;
                    opacityAmount = 1
                    targetChild.classList.add('!rotate-0');
                    targetChild.classList.add('!translate-y-0');
                } else if (yPositionPxFromTop > 120) {
                    zoomTarget.classList.add('blur-md');
                    let inverseYPositionPercent = 1 - yPositionPercent;
                    opacityAmount = inverseYPositionPercent + .3;
                    scaleAmount = .9;
                    targetChild.classList.remove('!rotate-0');
                    targetChild.classList.remove('!translate-y-0');
                } else if (yPositionPercent < .95) {
                    zoomTarget.classList.add('blur-md');
                    opacityAmount = yPositionPercent + .3;
                    scaleAmount = .9;
                    targetChild.classList.remove('!rotate-0');
                    targetChild.classList.remove('!translate-y-0');
                }

                zoomTarget.style.transform = `scale(${scaleAmount})`;
                targetChild.style.opacity = opacityAmount;

            } else {
                return;
            }

        }
    }
});